import { Switch, Redirect } from 'react-router-dom';

import {
  UnauthenticatedRoute,
  ProtectedRoute,
  ROOT,
  LOGIN,
  SIGNUP_REQUEST,
  SIGNUP,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD,
  PORTAL_DISABLED,
} from 'ui_system/token_auth/routes';

import SignUpPage from 'ui_system/token_auth/SignUpPage';
import SignUpRequestPage from 'ui_system/token_auth/SignUpRequestPage';
import LoginPage from 'ui_system/token_auth/LoginPage';
import ResetPasswordRequestPage from 'ui_system/token_auth/ResetPasswordRequestPage';
import ResetPasswordPage from 'ui_system/token_auth/ResetPasswordPage';
import { PortalDisabledPage } from 'ui_system/token_auth/PortalDisabledPage';

import Api from 'data_system/affiliate_portal/api/rootApi';
import { ExperienceList } from './experiences/ExperienceList';
import { ExperienceDetails } from './experience_details/ExperienceDetails';
import { AccountSettings } from './profile/AccountSettings';
import { OrderHistory } from './profile/OrderHistory';

import { SETTINGS, EXPERIENCE, ORDER_HISTORY, PAYMENT_LINK } from './routes';

export function Router() {
  return (
    <Switch>
      <UnauthenticatedRoute path={SIGNUP}>
        <SignUpPage />
      </UnauthenticatedRoute>

      <UnauthenticatedRoute path={SIGNUP_REQUEST}>
        <SignUpRequestPage />
      </UnauthenticatedRoute>

      <UnauthenticatedRoute path={LOGIN}>
        <LoginPage />
      </UnauthenticatedRoute>

      <UnauthenticatedRoute path={PORTAL_DISABLED}>
        <PortalDisabledPage />
      </UnauthenticatedRoute>

      <UnauthenticatedRoute path={RESET_PASSWORD_REQUEST}>
        <ResetPasswordRequestPage
          resetPasswordRequest={Api.resetPasswordRequest}
        />
      </UnauthenticatedRoute>

      <UnauthenticatedRoute path={RESET_PASSWORD}>
        <ResetPasswordPage />
      </UnauthenticatedRoute>

      <ProtectedRoute path={SETTINGS}>
        <AccountSettings />
      </ProtectedRoute>

      <ProtectedRoute path={[EXPERIENCE, PAYMENT_LINK]}>
        <ExperienceDetails />
      </ProtectedRoute>

      <ProtectedRoute path={ORDER_HISTORY}>
        <OrderHistory />
      </ProtectedRoute>

      <ProtectedRoute exact path={ROOT}>
        <ExperienceList />
      </ProtectedRoute>

      <Redirect to={ROOT} />
    </Switch>
  );
}
